/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量24
 * @export
 * @interface Col24
 */
export interface Col24 {
}

/**
 * Check if a given object implements the Col24 interface.
 */
export function instanceOfCol24(value: object): value is Col24 {
    return true;
}

export function Col24FromJSON(json: any): Col24 {
    return Col24FromJSONTyped(json, false);
}

export function Col24FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col24 {
    return json;
}

export function Col24ToJSON(json: any): Col24 {
    return Col24ToJSONTyped(json, false);
}

export function Col24ToJSONTyped(value?: Col24 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

